import {
  FETCH_NOTIFICATION_SUCCESS,
  GET_NOTIFICATION_SUCCESS,
  SAVE_NOTIFICATION_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_NOTIFICATION_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_NOTIFICATION_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case FETCH_NOTIFICATION_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }
    default:
      return state;
  }
}
